import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../api/client.jsx';
import { useApiMutation } from '../../api/mutations';

/**
 * #187 P6 / #228 — Reseller-Operator-Verwaltung (Orbit). Nutzt die vorhandenen
 * CORE-Admin-Endpoints (operator-gated):
 *   GET  /v1/admin/resellers?status=
 *   POST /v1/admin/resellers/:id/approve
 *   POST /v1/admin/resellers/:id/status   { status, reason }
 */
export function useResellers({ status = '' } = {}) {
  const { fetch } = useApiClient();
  return useQuery({
    queryKey: ['resellers', { status }],
    queryFn: () => fetch(`/v1/admin/resellers${status ? `?status=${encodeURIComponent(status)}` : ''}`),
    staleTime: 30_000,
  });
}

export function useApproveReseller() {
  return useApiMutation({
    live: (fetch, { id }) => fetch(`/v1/admin/resellers/${id}/approve`, { method: 'POST' }),
    fixture: ({ id }) => ({ reseller: { id, status: 'active' } }),
    invalidate: ['resellers'],
    successMessage: () => 'Reseller freigegeben.',
  });
}

export function useSetResellerStatus() {
  return useApiMutation({
    live: (fetch, { id, status, reason }) =>
      fetch(`/v1/admin/resellers/${id}/status`, { method: 'POST', body: { status, reason } }),
    fixture: ({ id, status }) => ({ reseller: { id, status } }),
    invalidate: ['resellers'],
    successMessage: (_res, { status }) => `Status auf „${status}" gesetzt.`,
  });
}
